import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Campaigns from "@/pages/Campaigns";
import EditorialCalendar from "@/pages/EditorialCalendar";
import CopyStudio from "@/pages/CopyStudio";
import Scripts from "@/pages/Scripts";
import Briefs from "@/pages/Briefs";
import DesignBoard from "@/pages/DesignBoard";
import Tasks from "@/pages/Tasks";
import BrandKit from "@/pages/BrandKit";
import AuraAI from "@/pages/AuraAI";
import Posts from "@/pages/Posts";
import Meetings from "@/pages/Meetings";
import Competition from "@/pages/Competition";
import Alerts from "@/pages/Alerts";
import Creators from "@/pages/Creators";
import Files from "@/pages/Files";
import Booking from "@/pages/Booking";
import AgendarPublico from "@/pages/AgendarPublico";
import Integrations from "@/pages/Integrations";
import PushMarketing from "@/pages/PushMarketing";
import EmailMarketing from "@/pages/EmailMarketing";
import Approvals from "@/pages/Approvals";
import CampaignCommand from "@/pages/CampaignCommand";
import VideoLab from "@/pages/VideoLab";
import Workspace from "@/pages/Workspace";

import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="spinner" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/agendar/:slug" element={<AgendarPublico />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/campanas" element={<Protected><Campaigns /></Protected>} />
          <Route path="/calendario" element={<Protected><EditorialCalendar /></Protected>} />
          <Route path="/copy-studio" element={<Protected><CopyStudio /></Protected>} />
          <Route path="/guiones" element={<Protected><Scripts /></Protected>} />
          <Route path="/briefs" element={<Protected><Briefs /></Protected>} />
          <Route path="/diseno" element={<Protected><DesignBoard /></Protected>} />
          <Route path="/tareas" element={<Protected><Tasks /></Protected>} />
          <Route path="/brand-kit" element={<Protected><BrandKit /></Protected>} />
          <Route path="/aura-ai" element={<Protected><AuraAI /></Protected>} />
          <Route path="/publicaciones" element={<Protected><Posts /></Protected>} />
          <Route path="/reuniones" element={<Protected><Meetings /></Protected>} />
          <Route path="/competencia" element={<Protected><Competition /></Protected>} />
          <Route path="/avisos" element={<Protected><Alerts /></Protected>} />
          <Route path="/creadores" element={<Protected><Creators /></Protected>} />
          <Route path="/archivos" element={<Protected><Files /></Protected>} />
          <Route path="/agendamiento" element={<Protected><Booking /></Protected>} />
          <Route path="/integraciones" element={<Protected><Integrations /></Protected>} />
          <Route path="/push-marketing" element={<Protected><PushMarketing /></Protected>} />
          <Route path="/email-marketing" element={<Protected><EmailMarketing /></Protected>} />
          <Route path="/aprobaciones" element={<Protected><Approvals /></Protected>} />
          <Route path="/campaigns/:id" element={<Protected><CampaignCommand /></Protected>} />
          <Route path="/video-lab" element={<Protected><VideoLab /></Protected>} />
          <Route path="/mi-workspace" element={<Protected><Workspace /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
